import React from 'react';

export const Pill = ({
  children,
  style,
  title,
}: {
  children: React.ReactNode;
  style?: React.CSSProperties;
  title?: string;
}) => {
  return (
    <div
      title={title}
      style={{
        padding: '5px 10px',
        backgroundColor: '#EEF1F4',
        color: '#333',
        borderRadius: '8px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        ...style,
      }}
    >
      {children}
    </div>
  );
};
